import { View, VStack } from "@gluestack-ui/themed";
import { SimulateInstallmentsValueController } from "./controller";
import { Text } from "@repo/core/components/core/Text";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";
import { IdentityTypeInput } from "@repo/core/components/forms/IdentityTypeInput";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const SimulateInstallmentsValue = () => {
  const {
    back,
    isMobile,
    control,
    isSubmitting,
    handleOnSubmitForm,
    handleOnChangeIdentityType,
    handleOnSelectProduct,
    selectedIdentityInputType,
    isValid
  } = SimulateInstallmentsValueController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title="Simular Parcelamento">
        <Scaffolds.Form
          showHeader={false}
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$0" : "$12"}
              px="$4"
              pb="$4"
              justifyContent="flex-end"
            >
              <Button
                flex={isMobile ? undefined : 1}
                size="xl"
                isLoading={isSubmitting}
                text="Simular"
                onPress={handleOnSubmitForm}
                isDisabled={!isValid}
              />
              <Button
                flex={isMobile ? undefined : 1}
                isDisabled={isSubmitting}
                variant="outline"
                action="negative"
                size="xl"
                text="Cancelar"
                onPress={back}
              />
            </View>
          }
        >
          <VStack flex={1} gap={24} px="$4">
            <Text>Insira os dados para consultar:</Text>

            <IdentityTypeInput
              control={control}
              selectedInputType={selectedIdentityInputType}
              onChangeInputType={handleOnChangeIdentityType}
              onSelectProduct={handleOnSelectProduct}
              onFetchCardFinish={handleOnSelectProduct}
              showCardExpiryInput={false}
            />

            <InputControlled
              control={control}
              name="installmentsValue"
              size="md"
              returnKeyType="next"
              label="Valor da compra"
              isRequired
              isCurrency
              isBigInput
              keyboardType="numeric"
              enterKeyHint="next"
            />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default SimulateInstallmentsValue;
